import { RadioGroup, styled } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { useController } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { Radio } from "./radio";

const ValidatingRadioGroup = styled(RadioGroup)(({ theme }) => ({
  gap: theme.spacing(1),
}));

/** @deprecated potential-component */
export const YesNoRadio: FC<{ name: string }> = ({ name }) => {
  const { field, fieldState } = useController({
    name,
  });

  return (
    <ValidatingRadioGroup row>
      <Radio
        checked={field.value === true}
        onClick={() => field.onChange(true)}
        error={!!fieldState.error}
        data-testid={`${name}.yes`}
      >
        <Typography>
          <FormattedMessage id="yes-no-radio.yes" defaultMessage="Yes" />
        </Typography>
      </Radio>
      <Radio
        checked={field.value === false}
        onClick={() => field.onChange(false)}
        error={!!fieldState.error}
        data-testid={`${name}.no`}
      >
        <Typography>
          <FormattedMessage id="yes-no-radio.no" defaultMessage="No" />
        </Typography>
      </Radio>
    </ValidatingRadioGroup>
  );
};
